const initialState = [];
//
export default function cmSdepth0001(state = initialState, action) {
  switch (action.type) {
    case 'SET_CMSDEPTH0001':
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    case 'SET_CMSDEPTH0001_ERROR':
      return state;
    default:
      return state;
  }
}
